var _path, _rect, _rect2, _rect3, _text, _text2, _text3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18a6 6 0 0 1 6-6h32a6 6 0 0 1 6 6v19.429a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6V18Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 20,
    width: 9.5,
    height: 16,
    rx: 2,
    fill: "#0E4C96"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 20,
    width: 9.5,
    height: 16,
    rx: 2,
    fill: "#D71920"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 20,
    width: 9.5,
    height: 16,
    rx: 2,
    fill: "#00A94F"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 17.75,
    y: 32.3,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "J")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 32.3,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "C")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 38.25,
    y: 32.3,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "B")));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.3c7fa2e6.svg";
export { ForwardRef as ReactComponent };